// Today's main check failure, kept until a newer whole check passes.
// A running or cancelled check does not withdraw the last completed result.
import type { Project, Run } from '../api/types'
import { useBoardState } from '../store/context'

export function mainFailure(project: Project, runs: Iterable<Run>): Run | undefined {
  const latest = [...runs].filter(r => r.project === project.id && r.main_check
    && r.actor.kind === 'poulpe' && r.main_check.repository === project.repository
    && r.main_check.branch === project.branch && (r.status === 'failed' || r.status === 'passed'))
    .sort((a, b) => b.started_at.localeCompare(a.started_at) || b.id.localeCompare(a.id))[0]
  return latest?.status === 'failed' ? latest : undefined
}

export function MainCheckFailure({ project }: { project: Project }) {
  const { runs } = useBoardState()
  const failed = mainFailure(project, runs.values())
  if (!failed) return null
  return <section className="approval-strip" aria-label="Check fails on main">
    <details>
      <summary>Check fails on main · <code>{failed.sha?.slice(0, 12)}</code></summary>
      <p>Poulpe checked main whole while the queue was idle, and its check failed.</p>
      <p>Commit: <code>{failed.sha}</code></p>
      {failed.main_check?.output.map(output => <div className="ready-output" key={output.part}>
        <p>Output of {output.part}{output.truncated ? ', cut to its end' : ''}:</p>
        <pre>{output.tail || 'It printed nothing.'}</pre>
      </div>)}
      {failed.main_check?.output.length === 0 && <p>The runner sent no output.</p>}
      <p>Main can break where no proposal looked.</p>
    </details>
  </section>
}
